import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Filter, FilterOptions, OffersOfApplication } from '../../../share/type/result_type';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  @Input() filterData!: Filter;
  @Input() filterOptionsData!: FilterOptions;
  @Input() offersData!: OffersOfApplication[];
  @Input() filterOverlay!: boolean;
  @Input() eternalPage!: boolean;
  @Input() resultPage!: boolean;
  @Input() loanRequestError!: boolean;
  @Input() loanRequestErrorMessage!: string;

  @Output() filterOutput = new EventEmitter<string>();
  @Output() loanOutput = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  filterPost(): void {
    //---create pos request in parent component---
    this.filterOutput.emit();
    //---create pos request in parent component---
  }

  loanPost(): void {
    //---create pos request in parent component---
    this.loanOutput.emit();
    //---create pos request in parent component---
  }
}
